function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ThemeService, useTheme } from "../theme/theme.service";

/**
 * User interactions that can be handled by Eva.
 */
export let Interaction;
/**
 * Component states that can be handled by Eva.
 */

(function (Interaction) {
  Interaction["HOVER"] = "hover";
  Interaction["ACTIVE"] = "active";
  Interaction["FOCUSED"] = "focused";
  Interaction["INDETERMINATE"] = "indeterminate";
  Interaction["VISIBLE"] = "visible";
})(Interaction || (Interaction = {}));

export let State;
/**
 * Takes a theme provided by ApplicationProvider or ThemeProvider and applies it to style.
 * Consider not using this function when not using Eva theme variables.
 *
 * @overview-example UseStyleSheetSimpleUsage
 */

(function (State) {
  State["CHECKED"] = "checked";
  State["SELECTED"] = "selected";
  State["DISABLED"] = "disabled";
})(State || (State = {}));

export const useStyleSheet = styles => {
  const theme = useTheme();
  return StyleService.createThemed(styles, theme);
};
/**
 * Service for creating styles that fit current theme.
 * Unlike StyleSheet class exported from React Native package, it allows using Eva theme variables.
 */

export class StyleService {}

_defineProperty(StyleService, "create", styles => {
  return styles;
});

_defineProperty(StyleService, "createThemed", (styles, theme) => {
  return Object.keys(styles).reduce((acc, key) => {
    return _objectSpread(_objectSpread({}, acc), {}, {
      [key]: StyleService.createThemedEntry(styles[key], theme)
    });
  }, {});
});

_defineProperty(StyleService, "createThemedEntry", (style, theme) => {
  return Object.keys(style).reduce((acc, key) => {
    const value = style[key];
    return _objectSpread(_objectSpread({}, acc), {}, {
      [key]: ThemeService.getValue(value, theme, value)
    });
  }, {});
});